module.exports = __webpack_public_path__ + "static/media/Microbrew-Three-3D-Regular.8fd50719.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Microbrew-Three-3D-Regular.otf
// module id = 2267
// module chunks = 50